
export function reportError(message: string, object?: any) {
	console.log(message, object)
}

export function logBreadCrumb(tag: 'network' | 'database' | 'navigation' | 'action', message: string, data?: object) {
	console.log('breadcrumb', tag, message, data)
}